export function max(value1, value2) {
    return value1 > value2 ? value1 : value2;
}
export function min(value1, value2) {
    return value1 < value2 ? value1 : value2;
}
export function abs(value) {
    return value < 0 ? -value : value;
}
